import { SVGProps } from 'react';
import { tokens } from '../../core/theme';

type ChevronDownIconProps = SVGProps<SVGSVGElement> & { color?: string };

export const ChevronDownIcon = ({
  width = 24,
  height = 24,
  color = tokens.colors.brand.gray.dark650,
  ...props
}: ChevronDownIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 10L12 14L16 10"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
